/**
 * As fontes de uma resposta.
 *
 * ADR-0003: nenhum numero sobre dados pessoais aparece sem dizer de onde veio.
 * Cada fonte e tocavel e leva a area a que pertence, para ela poder ir ver o
 * registro com os proprios olhos em vez de acreditar no assistente.
 *
 * O dono de uma entidade e o prefixo do nome (`finance.transaction` -> `finance`)
 * — isso e a convencao de nomes da plataforma, declarada em `@flos/shared`, e
 * nao conhecimento de dominio.
 */
import { List, ListItem, SectionHeading, Stack } from '@flos/ui';
import type { Citation } from '@flos/shared';
import type { RegisteredRoute } from '@flos/core';

export interface CitationListProps {
  citations: Citation[];
  routes: readonly RegisteredRoute[];
  onOpen?: (path: string) => void;
}

export function pluginOfEntity(entity: string): string {
  const dot = entity.indexOf('.');
  return dot === -1 ? entity : entity.slice(0, dot);
}

export function routeForCitation(
  citation: Citation,
  routes: readonly RegisteredRoute[],
): string | null {
  const pluginId = pluginOfEntity(citation.entity);
  const candidates = routes.filter((route) => route.pluginId === pluginId);
  const primary = candidates.find((route) => route.primary) ?? candidates[0];
  return primary?.fullPath ?? null;
}

export function CitationList({ citations, routes, onOpen }: CitationListProps) {
  if (citations.length === 0) return null;

  return (
    <Stack gap="sm">
      <SectionHeading>De onde vem esta resposta</SectionHeading>
      <List label="Registros que sustentam a resposta">
        {citations.map((citation) => {
          const path = routeForCitation(citation, routes);
          return (
            <ListItem
              key={`${citation.entity}:${citation.recordId}`}
              title={citation.label}
              icon="🔎"
              {...(path && onOpen ? { onClick: () => onOpen(path) } : {})}
            />
          );
        })}
      </List>
    </Stack>
  );
}
